import { Modal, Grid } from "semantic-ui-react";
import styles from "./SuccessMarketplaceModal.module.scss";
import useWeb3 from "@/hooks/useWeb3";
const MarketplaceNotification = () => {
  /*On a new message, show the modal with the message content */
  const { modalBody, openModal, closeNotification, modalTitle } = useWeb3();

  if (!openModal) {
    return null;
  }

  function createMarkup() {
    return { __html: `<p>${modalBody}</p>` };
  }

  return (
    <>
      <Modal
        onClose={closeNotification}
        open={openModal}
        className={styles.modal}
      >
        <Modal.Content className={styles.modalContent}>
          <Modal.Description>
            <Grid>
              <Grid.Row>
                <div className={styles.modalBody}>
                  <h4>{modalTitle}</h4> <br></br>
                  <div
                    style={{ fontSize: "10px !important" }}
                    dangerouslySetInnerHTML={createMarkup()}
                  />
                </div>
              </Grid.Row>
            </Grid>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default MarketplaceNotification;
